//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// FIXME: dp-modal breaks layout when sharing dp-container with multiple tables
// (https://github.com/DevicePilot/devicepilot/issues/434)
export default {
  name: 'DpTable',
  props: {
    title: { type: String, default: null },
    smallFont: { type: Boolean, default: false },
  },
};
